import { render, staticRenderFns } from "./edit-gallery-settings.vue?vue&type=template&id=190ac7b6&scoped=true&"
import script from "./edit-gallery-settings.vue?vue&type=script&lang=ts&"
export * from "./edit-gallery-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190ac7b6",
  null
  
)

export default component.exports